export enum ChildBioDisplayVariants {
  DEFAULT = 'default',
  STICKY = 'sticky',
}

export const getAge = (ageInYearsAndMonths: string) => {
  return ageInYearsAndMonths.split(' Years')[0];
};
